<template>
    <div>
        <div class="form-check form-switch link">
            <input class="form-check-input link" type="checkbox" role="switch" :id="internalId" v-model="internalValue">
            <label class="form-check-label link" :for="internalId">{{ title }}</label>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            internalValue: this.modelValue,
            internalId: this.id ? this.id : this.$helper.randomString(7),
        };
    },
    watch: {
        modelValue(val) {
            this.internalValue = val;
        },
        internalValue(val) {
            this.$emit('update:modelValue', val);
            this.$emit('change', val);
        },
    },
};
</script>
